import React from 'react';
import PropTypes from 'prop-types';
import { MainContent, ContentBox, ContenFooter } from '../styles';

const propTypes = {
  actionBar: PropTypes.node,
  footer: PropTypes.node,
  children: PropTypes.node,
  transparent: PropTypes.bool,
  overflow: PropTypes.string
};

function PageContent({ actionBar, footer, children, transparent, overflow }) {
  return (
    <MainContent transparent={transparent} overflow={overflow}>
      {actionBar}
      <ContentBox overflow={overflow} transparent={transparent}>
        {children}
      </ContentBox>
      {footer && <ContenFooter>{footer}</ContenFooter>}
    </MainContent>
  );
}

PageContent.propTypes = propTypes;

export default PageContent;



// WEBPACK FOOTER //
// ./src/modules/theme/theme1/layout/components/PageContent.js